import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import type { SelectOption } from "./types";

interface Props {
  modelValue?: Array<string | number | boolean>;
  options?: SelectOption[];
  disabled?: boolean;
  name?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckboxGroup',
  props: {
    modelValue: { default: () => [] },
    options: { default: () => [] },
    disabled: { type: Boolean, default: false },
    name: { default: undefined }
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const normalizedOptions = computed(() =>
  (props.options || []).map((opt) => ({
    label: opt.label,
    value: opt.value,
    disabled: opt.disabled,
  }))
);

const innerValue = computed({
  get: () => props.modelValue ?? [],
  set: (val: Array<string | number | boolean>) => {
    emit("update:modelValue", val);
    emit("change", val);
  },
});

const onChange = (val: Array<string | number | boolean>) => {
  emit("update:modelValue", val);
  emit("change", val);
};

return (_ctx: any,_cache: any) => {
  const _component_a_checkbox_group = _resolveComponent("a-checkbox-group")!

  return (_openBlock(), _createBlock(_component_a_checkbox_group, {
    value: innerValue.value,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((innerValue).value = $event)),
    disabled: _ctx.disabled,
    options: normalizedOptions.value.length ? normalizedOptions.value : undefined,
    name: _ctx.name,
    class: "ant-checkbox-group-wrap",
    onChange: onChange
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["value", "disabled", "options", "name"]))
}
}

})